/**
 * @generated SignedSource<<46fdecf31761f946953adb7e46150366>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoomRatesEditorInit_data$data = {
  readonly " $fragmentSpreads": FragmentRefs<"RoomRatesEditorCateringSettings_data">;
  readonly " $fragmentType": "RoomRatesEditorInit_data";
};
export type RoomRatesEditorInit_data$key = {
  readonly " $data"?: RoomRatesEditorInit_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoomRatesEditorInit_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoomRatesEditorInit_data",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoomRatesEditorCateringSettings_data"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "11dce30cada44ae7c1bf00767883265b";

export default node;
